import React from "react";

export default function ReprintBill() {
    return (
        <>
        </>
    )
}